import {
  ProfileDetailsGameplay,
  type ProfileDetailsGameplayHeaderProps,
  type ProfileDetailsGameplayLastPlayedProps,
  type ProfileDetailsGameplayMostPlayedAgentsProps,
  type ProfileDetailsGameplayPlayerInfoProps,
  type ProfileDetailsGameplayRankProps,
  type ProfileDetailsGameplayRootProps,
  type ProfileDetailsGameplaySkillOverviewProps,
  type ProfileDetailsGameplaySocialOverviewProps,
} from './gameplay';
import { ProfileDetailsHeader, type ProfileDetailsHeaderProps } from './header';
import {
  ProfileDetailsRoot,
  type ProfileDetailsRootProps,
} from './profileDetailsRoot';
import {
  ProfileDetailsVibe,
  type ProfileDetailsVibeCommsVibeProps,
  type ProfileDetailsVibeDuoPersonalityProps,
  type ProfileDetailsVibeHeaderProps,
  type ProfileDetailsVibePlayTimeProps,
  type ProfileDetailsVibePreGameRitualProps,
} from './vibe';

export const ProfileDetails = {
  Root: ProfileDetailsRoot,
  Header: ProfileDetailsHeader,
  Gameplay: ProfileDetailsGameplay,
  Vibe: ProfileDetailsVibe,
} as const;

export type {
  ProfileDetailsGameplayHeaderProps,
  ProfileDetailsGameplayLastPlayedProps,
  ProfileDetailsGameplayMostPlayedAgentsProps,
  ProfileDetailsGameplayPlayerInfoProps,
  ProfileDetailsGameplayRankProps,
  ProfileDetailsGameplayRootProps,
  ProfileDetailsGameplaySkillOverviewProps,
  ProfileDetailsGameplaySocialOverviewProps,
  ProfileDetailsHeaderProps,
  ProfileDetailsRootProps,
  ProfileDetailsVibeCommsVibeProps,
  ProfileDetailsVibeDuoPersonalityProps,
  ProfileDetailsVibeHeaderProps,
  ProfileDetailsVibePlayTimeProps,
  ProfileDetailsVibePreGameRitualProps,
};
